var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.504,
    height: 29.602,
    viewBox: "0 0 23.504 29.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zip",
    transform: "translate(-1.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.239,26.959A2.646,2.646,0,0,1,73.591,29.6H55.383a2.646,2.646,0,0,1-2.648-2.643V2.643A2.646,2.646,0,0,1,55.383,0H66.718a1.988,1.988,0,0,1,1.406.582l7.535,7.536a1.98,1.98,0,0,1,.58,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.357,11.62h-6.729a1.791,1.791,0,0,1-1.79-1.791V3.1a1.967,1.967,0,0,1,.582.4l7.535,7.536a1.967,1.967,0,0,1,.4.581Z",
    transform: "translate(-292.751 -2.922)",
    fill: "#323d5d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15226",
    "data-name": "Group 15226",
    transform: "translate(11.097 8.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13602",
    "data-name": "Path 13602",
    d: "M24.638,12.413V11.7h.712v-.712h-.712v-.712h.712V9.563h-.712V8.85h.712V8.138h-.712V7.425h.712V6.712h-.712V6h-.712v.712h-.713v.713h.712v.712h-.712V8.85h.712v.712h-.712v.712h.712v.712h-.712V11.7h.712v.712H22.5v1.78a1.781,1.781,0,1,0,3.563,0v-1.78Zm.712,1.78a1.069,1.069,0,1,1-2.138,0V13.126H25.35Z",
    transform: "translate(-22.5 -6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13603",
    "data-name": "Path 13603",
    d: "M25.846,28.712h.712a.356.356,0,0,0,0-.712h-.712a.356.356,0,1,0,0,.712Z",
    transform: "translate(-24.421 -20.162)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13604",
    "data-name": "Path 13604",
    d: "M.359-7.877H3.2v.652l-1.825,1.9H3.268v.7H.183V-5.3L1.989-7.182H.359Zm3.565,0H4.93v3.251H3.923Zm1.889,0h1.67a1.143,1.143,0,0,1,.817.259.973.973,0,0,1,.272.738,1,1,0,0,1-.3.769,1.283,1.283,0,0,1-.9.278h-.55v1.207H5.81ZM6.822-6.488h.246a.633.633,0,0,0,.408-.1.325.325,0,0,0,.118-.258.361.361,0,0,0-.1-.259.529.529,0,0,0-.384-.107H6.822Z",
    transform: "translate(8.513 29.832)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/Zip.a9b9d1f9f5cec3a1ab029d37d16b88e3.svg";
export { ForwardRef as ReactComponent };